import EmailsService from "services/EmailsService"

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit")

export const getEmails = createAsyncThunk(
  "emails/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EmailsService.getEmails()
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.response || "Erreur")
    }
  }
)

// export const getEmailById = createAsyncThunk(
//   "emails/getEmailById",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await EmailsService.getEmailById(id);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response || "Erreur");
//     }
//   }
// );

export const createEmail = createAsyncThunk(
  "emails/createEmail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmailsService.createEmail(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data.error || "Erreur")
    }
  }
)

export const deleteEmailById = createAsyncThunk(
  "emails/deleteEmailById",
  async (id, { rejectWithValue }) => {
    try {
      // TODO: this is supposed to return the deleted email id, but the API returns only a status message
      await EmailsService.deleteEmailById(id)
      return id
    } catch (error) {
      return rejectWithValue(error.response || "Erreur")
    }
  }
)

const initialState = {
  emails: [],
  email: null,
  loading: false,
  error: null,
}

const emailsSlice = createSlice({
  name: "emails",
  initialState,
  reducers: {
    setEmails: (state, { payload }) => {
      state.emails = payload
    },
    setEmail: (state, { payload }) => {
      state.email = payload
    },
    setLoading: (state, { payload }) => {
      state.loading = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
  },
  extraReducers: {
    [getEmails.pending]: (state) => {
      state.loading = true
    },
    [getEmails.fulfilled]: (state, { payload }) => {
      state.emails = payload
      state.loading = false
    },
    [getEmails.rejected]: (state, { payload }) => {
      state.error = payload
      state.loading = false
    },
    // [getEmailById.pending]: (state) => {
    //   state.loading = true;
    // },
    // [getEmailById.fulfilled]: (state, { payload }) => {
    //   state.email = payload;
    //   state.loading = false;
    // },
    // [getEmailById.rejected]: (state, { payload }) => {
    //   state.loading = false;
    // },
    [createEmail.pending]: (state, { payload }) => {
      state.loading = true
    },
    [createEmail.fulfilled]: (state, { payload }) => {
      state.emails.push(payload.emailForFormer)
      state.loading = false
    },
    [createEmail.rejected]: (state, { payload }) => {
      state.loading = false
    },
    [deleteEmailById.pending]: (state) => {
      state.loading = true
    },
    [deleteEmailById.fulfilled]: (state, { payload }) => {
      state.emails = state.emails.filter((email) => email._id !== payload)
      state.loading = false
    },
    [deleteEmailById.rejected]: (state, { payload }) => {
      state.loading = false
    },
  },
})

export const { setEmails, setEmail, setLoading, setError } = emailsSlice.actions

export default emailsSlice.reducer
